export const filterEmail = (email: string) => {
  return 'mailto:' + email
}
